import { Dropdown, Modal } from 'antd';
import clsx from 'clsx';
import React from 'react';

import PlayerTooltip from '@/components/PdfReader/VideoSummary/PlayerTooltip';

const VideoIndexMenu = ({
  items,
  isFullscreen,
  setOpen,
  open,
  icon,
  placement,
  title,
  buttonName,
}: {
  items: any;
  isFullscreen: boolean;
  setOpen: (flag: boolean) => void;
  open: boolean;
  icon?: React.ReactNode;
  title: string;
  buttonName: string;
  placement?:
    | 'top'
    | 'bottom'
    | 'topLeft'
    | 'topRight'
    | 'bottomLeft'
    | 'bottomRight';
}) => {
  if (isFullscreen) {
    return (
      <>
        <PlayerTooltip key={buttonName} title={buttonName}>
          <button
            className='w-6 h-6 md:w-16 md:h-16 !rounded-full !flex !items-center !justify-center hover:!bg-[#ffffff4d]'
            onClick={() => setOpen(true)}
          >
            {icon}
          </button>
        </PlayerTooltip>
        <Modal
          footer={null}
          title={
            <div
              className={clsx(
                'bg-dropDownMenuBg',
                'flex items-start py-4 px-6 rounded-t-xl text-white text-2xl font-semibold',
              )}
            >
              {title}
            </div>
          }
          open={open}
          onCancel={() => setOpen(false)}
          className='customPdfVideoPlayerModal'
          centered
          destroyOnHidden
          classNames={{
            content: 'p-0 w-full md:rounded-xl',
          }}
          {...(isFullscreen && { getContainer: false })}
        >
          <div className='flex flex-col max-h-[540px] overflow-y-auto overflow-x-hidden'>
            {items.map((item: any) => (
              <div
                key={item.key}
                className='py-3 px-4 hover:bg-grayZl-900 text-white cursor-pointer'
                onClick={() => {
                  item.onClick?.();
                  setOpen(false);
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        </Modal>
      </>
    );
  }

  return (
    <Dropdown
      menu={{ items }}
      placement={placement || 'top'}
      trigger={['hover']}
      rootClassName='customPdfVideoPlayerDropdown rounded-t-none'
      open={open}
      popupRender={(menu) => (
        <div>
          <div
            className={clsx(
              'bg-dropDownMenuBg',
              'flex items-start py-4 px-6 rounded-t-xl text-white text-2xl font-semibold',
            )}
          >
            {title}
          </div>
          {React.cloneElement(
            menu as React.ReactElement<{
              style: React.CSSProperties;
            }>,
          )}
        </div>
      )}
      autoAdjustOverflow
      onOpenChange={(flag) => {
        setOpen(flag);
      }}
    >
      <button
        aria-label={buttonName}
        className='w-6 h-6 md:w-16 md:h-16 !rounded-full !flex !items-center !justify-center hover:!bg-[#ffffff4d]'
      >
        {icon}
      </button>
    </Dropdown>
  );
};
export default VideoIndexMenu;
